import ReactMarkdown from 'react-markdown';

const AboutPage = () => {

  const markdownContent = 

` 
I'm from Toronto and now live in San Francisco. 

I am interested in startups that solve meaningful problems and help lift economic prosperity for the many.

I currently work at [Bretton AI](https://www.bretton.com/) on deployment teams. Before this, I spent 2 years at [Meter](https://www.meter.com/) working across business teams.

I'm an aspiring triathlete and enjoy skiing, Italian restaurants, backpacking trips, and Nolan movies. 

  `;
  
    return (
      <div>
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    );
  };

export default AboutPage
  
